module.exports = __webpack_public_path__ + "static/media/(000015).c3e21775.jpg";